import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

const benefit1Img = getS3ImageUrl('/mobile-app/content-benefit-1.png');
const benefit1Img2x = getS3ImageUrl('/mobile-app/content-benefit-1-2x.png');
const benefit2Img = getS3ImageUrl('/mobile-app/content-benefit-2.png');
const benefit2Img2x = getS3ImageUrl('/mobile-app/content-benefit-2-2x.png');
const benefit3Img = getS3ImageUrl('/mobile-app/content-benefit-3.png');
const benefit3Img2x = getS3ImageUrl('/mobile-app/content-benefit-3-2x.png');

const benefitsData = [
  { img: benefit1Img, img2x: benefit1Img2x, text: 'mobileApp.contentBenefits.item1.text' },
  { img: benefit2Img, img2x: benefit2Img2x, text: 'mobileApp.contentBenefits.item2.text' },
  { img: benefit3Img, img2x: benefit3Img2x, text: 'mobileApp.contentBenefits.item3.text' },
];

const ContentBenefits = () => {
  const [t] = useTranslation();

  return (
    <div className="c-benefits section">
      <div className="page-content">
        <Typography className="c-benefits__title" align="center" variant="h2">
          {t('mobileApp.contentBenefits.title')}
        </Typography>
        <Grid container spacing={3}>
          {benefitsData.map((item, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <img
                className="c-benefits__img m-b-25"
                srcSet={`${item.img2x} 2x`}
                src={item.img}
                alt="benefit"
              />
              <Typography className="c-benefits__text text-regular p1 m-b-25" align="center">
                {t(item.text)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default React.memo(ContentBenefits);
